export const ArrowDownGreen: React.FC = () => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 1.48656L5.99999 7.48657L-1.99556e-05 1.48656L1.48658 -3.44576e-05L5.99999 4.51338L10.5134 -3.435e-05L12 1.48656Z"
                fill="#00DD5E"
            />
        </svg>
    );
};
